import { useEffect } from 'react';
import VideoPlayer from './VideoPlayer';

export default function VideoPlayerModal({
  target,
  isOpen,
  onClose,
  isLoggedIn,
  onRequireAuth,
  onRequireSubscription,
  onComplete,
  onError,
}) {
  useEffect(() => {
    if (!isOpen) return undefined;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose?.();
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen || !target) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4 py-8"
      role="dialog"
      aria-modal="true"
      aria-label={target.title || 'Video player'}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose?.();
      }}
    >
      <div className="w-full max-w-4xl overflow-hidden rounded-2xl bg-zinc-950 shadow-2xl">
        <div className="flex items-center justify-between gap-3 border-b border-white/10 px-4 py-3">
          <p className="min-w-0 truncate text-sm font-semibold text-white">
            {target.title || 'Video'}
          </p>
          <button
            type="button"
            onClick={onClose}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white/90 transition hover:bg-white/10"
            aria-label="Close video"
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <VideoPlayer
          target={target}
          isLoggedIn={isLoggedIn}
          onRequireAuth={onRequireAuth}
          onRequireSubscription={onRequireSubscription}
          onComplete={onComplete}
          onError={onError}
          autoplay
        />
      </div>
    </div>
  );
}
